export default __webpack_public_path__ + "static/media/top-selling-products.f52f80e5.png";